export default (Alpine) => {

	Alpine.directive('auto-transition', (el, { expression }, { evaluate }) => {

		// This creates a shortcut: x-animation="slide-glow"
		const name = expression;

		el.setAttribute('x-transition:enter', `${name}-enter`);
		el.setAttribute('x-transition:enter-start', `${name}-enter-start`);
		el.setAttribute('x-transition:enter-end', `${name}-enter-end`);
		el.setAttribute('x-transition:leave', `${name}-leave`);
		el.setAttribute('x-transition:leave-start', `${name}-leave-start`);
		el.setAttribute('x-transition:leave-end', `${name}-leave-end`);

	});

};